export const SECTORS_NUMBERS_DICTIONARY = {
  'fuerzas-armadas': 1,
  'gobierno-central-y-universidades': 2,
  'legislativo-y-judicial': 3,
  municipalidades: 4,
  'obras-publicas': 5,
  otros: 6,
  salud: 7
}

export const SECTORS_DICTIONARY = {
  1: {
    banner: '/assets/images/army.jpg',
    icon: '/assets/images/army-icon.svg',
    slug: 'fuerzas-armadas'
  },
  2: {
    banner: '/assets/images/government-and-universities.jpg',
    icon: '/assets/images/government-and-universities-icon.svg',
    slug: 'gobierno-central-y-universidades'
  },
  3: {
    banner: '/assets/images/legislative-and-judicial.jpg',
    icon: '/assets/images/legislative-and-judicial-icon.svg',
    slug: 'legislativo-y-judicial'
  },
  4: {
    banner: '/assets/images/town-hall.jpg',
    icon: '/assets/images/town-hall-icon.svg',
    slug: 'municipalidades'
  },
  5: {
    banner: '/assets/images/public-works.jpg',
    icon: '/assets/images/public-works-icon.svg',
    slug: 'obras-publicas'
  },
  6: {
    banner: '/assets/images/others.jpg',
    icon: '/assets/images/others-icon.svg',
    slug: 'otros'
  },
  7: {
    banner: '/assets/images/health.jpg',
    icon: '/assets/images/health-icon.svg',
    slug: 'salud'
  }
}
